var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "obch-prip-wrapped" } },
    [
      _c("pripady-filter", {
        ref: "pripadyFilter",
        on: {
          filter: function(filter) {
            return _vm.$refs.table.loadData(filter)
          }
        }
      }),
      _c("pripady-table", {
        ref: "table",
        on: {
          reloadTable: function() {
            return _vm.$refs.pripadyFilter.applyFilter()
          }
        }
      }),
      _c("v-container", { staticClass: "pripady-table" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }